import { render } from "./CarInfo.vue?vue&type=template&id=0be19f64"
import script from "./CarInfo.vue?vue&type=script&lang=js"
export * from "./CarInfo.vue?vue&type=script&lang=js"

import "./CarInfo.vue?vue&type=style&index=0&id=0be19f64&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__